.StoreInfoSchedule {
  display: flex;
  flex-direction: column;
  gap: 4px;

  &__row {
    display: grid;
    grid-template-columns: auto auto;
    column-gap: 12px;
    row-gap: 3px;
  }

  &__item {
    margin-right: 24px;
    &--flex {
      display: flex;
      align-items: center;
    }
  }
  &__time {
    display: inline-block;
    &--red {
      color: #b32442;
    }
  }
}
